import { SelectProps } from 'antd';
import { useEffect, useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import useSelectOptions from '@/hooks/useSelectOptions';
import {
  SaleTag,
  SaleTagsQueryFilter,
} from '@/core/domain/sales/SaleTags/SaleTags.types';
import { useSalesTags } from '@/core/domain/sales/SaleTags/SaleTags.hooks';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: SaleTagsQueryFilter;
  queryEnable?: boolean;
};

export default function DirectSaleTagsInfiniteSelectField({
  queryFilter,
  queryEnable = false,
  ...props
}: Props) {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);
  const [searchValue, setSearchValue] = useState<string>();
  const name = useDebounce(searchValue);

  useEffect(() => {
    setSelectClicked(queryEnable);
  }, [queryEnable]);

  const tagList = useSalesTags(
    {
      ...queryFilter,
      rows: 10,
      name,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const options = useSelectOptions<SaleTag, SaleTag>({
    list: tagList,
    selectProps: props,
    labelFormatter: (tag) => tag.name,
  });

  return (
    <InfiniteSelect
      fetchNextPage={tagList.fetchNextPage}
      hasNextPage={tagList.hasNextPage}
      loading={tagList.isFetching}
      options={options}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
}
